

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import './index.css'
import styledNormalize from 'styled-normalize'
import { createGlobalStyle } from 'styled-components'
import Modal from 'react-modal'

import { Provider } from 'react-redux'
import store from './store'
import "../node_modules/video-react/dist/video-react.css";

import './i18n';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/zh-cn';

const GlobalStyles = createGlobalStyle`
  ${styledNormalize}

  body {
    margin: 0;
  }
`
// TODO: While developing I am going to use this tool to identify accessibility problems
// WE MUST remove after we finish or we should only use on development environment
// const a11y = require('react-a11y').default
// a11y(React, ReactDOM, {
//   rules: {
//     'img-uses-alt': 'warn',
//     'label-uses-for': 'warn'
//   , 'redundant-alt': [ 'warn', [ 'image', 'photo', 'foto', 'bild' ]]
//   // ...
//   }
// })

const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <GlobalStyles/>
      <App id="app-root" />
    </Provider>,
  document.getElementById('root'))
  Modal.setAppElement('#root')
}

renderApp()
registerServiceWorker()

if (module.hot) {
  module.hot.accept('./App', renderApp)
}
